import slackWebHook from '@/lib/slack-web-hook';
export default {
    install(Vue) {
        // Vue.prototype.slackWebHook = slackWebHook;
        // eslint-disable-next-line no-param-reassign
        Vue.config.globalProperties.slackWebHook = slackWebHook;
        Vue.provide('slackWebHook', slackWebHook);
    },
};
